// extracted by mini-css-extract-plugin
export default {"premiumContainer":"ActivationOfPremium_premiumContainer__6s38I"};